
const initialState = {
    bedsize: '',
    name: '',
    sku: '',
    toPrint: '',
    error: null
  }
  
  const toprint = (state = initialState, action) => {
    switch (action.type) {
      case 'FETCHING_TOPRINT':
        return {
          state,
          items: action.payload,
        }
      case 'FETCHING_TOPRINT_ERROR':
        return {
          state,
          error: null,
        }
      default:
        return state
    }
  }
  
  export default toprint


// WEBPACK FOOTER //
// ./src/reducers/toprint.js